export function getMonthWeeks(year, month) {
  const weeks = [];
  const firstDate = new Date(year, month - 1, 1);
  const lastDate = new Date(year, month, 0);
  const firstDayOfWeek = firstDate.getDay();
  const lastDateDay = lastDate.getDate();

  const lastDayOfFirstWeek = 7 - (firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1);

  let currentWeekStart = 1;
  let currentWeekEnd = lastDayOfFirstWeek;

  while (currentWeekStart <= lastDateDay) {
    if (currentWeekEnd > lastDateDay) {
      currentWeekEnd = lastDateDay;
    }

    weeks.push({ start: currentWeekStart, finish: currentWeekEnd });

    currentWeekStart = currentWeekEnd + 1;
    currentWeekEnd += 7;
  }

  return weeks;
}

function getWeekOfMonth(date) {
  const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);

  // Сдвиг, чтобы понедельник = 0, вторник = 1, ..., воскресенье = 6
  const dayOfWeek = (startOfMonth.getDay() + 6) % 7;

  const day = date.getDate();

  return Math.ceil((day + dayOfWeek) / 7);
}

export function splitArrayByWeeks(dataArray) {
  const weeks = [[], [], [], [], [], []];

  dataArray.forEach((item) => {
    const date = new Date(item.date);
    const week = getWeekOfMonth(date);

    if (week >= 1 && week <= 6) weeks[week - 1].push(item);
  });

  return weeks;
}
